import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useSelector } from "react-redux";
// assets
import { CreditCardOutlined, LockOutlined, SettingOutlined, UserOutlined, RocketOutlined } from '@ant-design/icons';

function getPathIndex(pathname) {
  let selectedTab = 0;
  switch (pathname) {
    case '/profiles/user/payment':
      selectedTab = 1;
      break;
    case '/profiles/user/password':
      selectedTab = 2;
      break;
    case '/profiles/user/personal':
      selectedTab=0;
      break;
    case '/profiles/user/xero-integrations':
      selectedTab = 3;
      break;
    case '/profiles/user/users':
      selectedTab = 4;
      break;
    default:
      selectedTab = 0;
  }
  return selectedTab;
}

const ProfileTab = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {selected_subscription} = useSelector((state) => state.xeroconnection);
  // const {plan_name} = selected_subscription?.plan_name != null || '';
  // const {plan_name} = selected_subscription?.plan_name;

  const [selectedIndex, setSelectedIndex] = useState(getPathIndex(pathname));
  const handleListItemClick = (index, route) => {
    setSelectedIndex(index);
    navigate(route);
  };

  useEffect(() => {
    setSelectedIndex(getPathIndex(pathname));
  }, [pathname]);

  function DisplayXeroIntegration({plan_name}) {
    if (plan_name == "Multi Organisation Plan"){
      return (<ListItemButton selected={selectedIndex === 3} onClick={() => handleListItemClick(3, '/profiles/user/xero-integrations')}>
        <ListItemIcon>
          <RocketOutlined />
        </ListItemIcon>
        <ListItemText primary="Xero Integrations" />
      </ListItemButton>)
    }
    else
      return null
  }

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
      <ListItemButton selected={selectedIndex === 0} onClick={() => handleListItemClick(0, '/profiles/user/personal')}>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="Personal Information" />
      </ListItemButton>
      <DisplayXeroIntegration
        plan_name={selected_subscription?.plan_name}
        />
      {/*<ListItemButton selected={selectedIndex === 3} onClick={() => handleListItemClick(3, '/profiles/user/xero-integrations')}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <RocketOutlined />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Xero Integrations" />*/}
      {/*</ListItemButton>*/}
      <ListItemButton selected={selectedIndex === 4} onClick={() => handleListItemClick(4, '/profiles/user/users')}>
        <ListItemIcon>
          <RocketOutlined />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 1} onClick={() => handleListItemClick(1, '/profiles/user/payment')}>
        <ListItemIcon>
          <CreditCardOutlined />
        </ListItemIcon>
        <ListItemText primary="Payment" />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 2} onClick={() => handleListItemClick(2, '/profiles/user/password')}>
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary="Change Password" />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
